module.exports = __webpack_public_path__ + "img/desalination-plant-text.8f76e003.svg";